import { CompanyForm } from "@/features/company/components/CompanyForm";
import { useCompanyInfo } from "@/api/services/main/company";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { convertResToFormData } from "@/features/company/utiles/convertCompanyFormData";
import { useValidateId } from "@/hooks/useValidateId";
import { AppRoutes } from "@/routes/config";

export const CompanyEditPage = () => {
  const queryResult = useCompanyInfo();
  const { data, isLoading } = queryResult;
  useValidateId("companyId", AppRoutes.companyList, queryResult);

  if (!data || isLoading) return <LoadingPage />;
  return <CompanyForm defaultValues={convertResToFormData(data.data)} />;
};
